import enScore from './en';
import ruScore from './ru';

export default {
  en: {
    ...enScore,
  },
  ru: {
    ...ruScore,
  },
};
